import { DashboardOutlined, ListAltOutlined } from '@mui/icons-material';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { Link } from 'react-router';

import Button from '@/components/Buttons/Button';
import { SPOT_CATALOG_PATH } from '@/constants/constants';

const buttonStyles: SxProps<Theme> = {
  width: 250,
  display: 'flex',
  justifyContent: 'flex-start',
  backgroundColor: 'info.light',
  '&:hover': {
    backgroundColor: 'info.dark'
  }
};

const EmptyDataHubScreen = () => {
  return (
    <Box
      sx={{
        mt: 12,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
      }}
    >
      <Typography
        sx={{ fontWeight: 700 }}
        variant='h4'
      >
        Data Hub is empty
      </Typography>
      <Typography sx={{ my: 4 }}>Let's get started by adding items through these links</Typography>
      <Button
        component={Link}
        sx={buttonStyles}
        to='/markets'
        variant='contained'
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <DashboardOutlined sx={{ fontSize: '20px!important' }} />
          <Box sx={{ ml: 0.5 }}>Homepage</Box>
        </Box>
      </Button>
      <Button
        component={Link}
        sx={{
          mt: 4,
          ...buttonStyles
        }}
        to={`/catalog/${SPOT_CATALOG_PATH}`}
        variant='contained'
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ListAltOutlined sx={{ fontSize: '20px!important' }} />
          <Box sx={{ ml: 0.5 }}>Catalog</Box>
        </Box>
      </Button>
    </Box>
  );
};

export default EmptyDataHubScreen;
